import PropTypes from 'prop-types';

import LandingPageLink from 'components/landing/LandingPageLink';

import styles from 'styles/components/landing/images.scss';

const Images = (props, { testId }) => {
  const { slotDetails, className, onLandingComponentClick, slotIndex } = props;
  const { images, monetateId } = slotDetails;
  if (slotDetails && images) {
    return (
      <div className={className || styles.imagesWrapper} data-test-id={testId('landingPageImages')} data-monetate-id={monetateId}>
        {images.map(image => {
          const { src, msrc, href, alt, width, title, gae } = image;
          if (href) {
            const linkProps = {
              'key': msrc || src,
              'onClick': onLandingComponentClick,
              'data-eventlabel': 'Promos',
              'data-eventvalue': gae,
              'data-slotindex': slotIndex
            };
            return (
              <LandingPageLink key={href} url={href} {...linkProps}>
                <img
                  src={msrc || src}
                  alt={alt}
                  width={width}
                  title={title}
                  data-te={props['data-te']}
                />
              </LandingPageLink>
            );
          } else {
            return <img
              key={msrc || src}
              src={msrc || src}
              alt={alt}
              width={width}
              title={title} />;
          }
        })}
      </div>
    );
  } else {
    return false;
  }
};

Images.contextTypes = {
  testId: PropTypes.func
};

export default Images;
